// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Data from "../core/Data.js";
import * as Buhta_cabinet__Kassa from "../grpc/Kassa.js";
import * as Buhta_cabinet__ReceiptBody from "../components/organisms/Kassa/KKM/ReceiptBody.js";
import * as Buhta_cabinet__ReceiptNotFound from "../components/organisms/Kassa/KKM/ReceiptNotFound.js";
import * as Buhta_cabinet__Route from "../Route.js";
import * as Buhta_components__Text from "../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../packages/util/lib/Formating.js";
import * as $$Promise from "../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(etp) {
  return function (id) {
    const currentUrl = Buhta_cabinet__Route.useUrl(undefined);
    const firstTime = React.useRef(true);
    const match = React.useState(function () {
          
        });
    const setError = match[1];
    const error = match[0];
    const receiptNum = Buhta_cabinet__Route.getParamValue(currentUrl, "receipt_num", undefined);
    const match$1 = Buhta_cabinet__Data.Context.useData(undefined);
    const dispatchData = match$1[1];
    const order = match$1[0].etpOrder;
    React.useEffect((function () {
            if (!firstTime.current || order.order_num === "") {
              const p = Buhta_cabinet__Kassa.EtpReceiptService.view(undefined, {
                    hd: "receipt.org",
                    tl: {
                      hd: "receipt.kkm",
                      tl: {
                        hd: "receipt.items",
                        tl: {
                          hd: "receipt.payments",
                          tl: {
                            hd: "receipt.notes",
                            tl: {
                              hd: "receipt.taxes",
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }, etp, id, receiptNum, undefined);
              $$Promise.getOk(p, (function (data) {
                      Curry._1(dispatchData, {
                            TAG: /* EtpOrder */1,
                            _0: data
                          });
                    }));
              $$Promise.getError(p, (function (error) {
                      Curry._1(setError, (function (param) {
                              return error;
                            }));
                    }));
              firstTime.current = false;
            }
            
          }), [
          etp,
          id
        ]);
    let tmp;
    if (error !== undefined) {
      tmp = JsxRuntime.jsx(Buhta_cabinet__ReceiptNotFound.make, {
            error: error
          });
    } else {
      const etpInfo = order.etp_info;
      let tmp$1;
      if (etpInfo !== undefined) {
        const details = etpInfo.details;
        if (details !== undefined && details.show_header === true) {
          const caption = Belt__Belt_List.keepMap(order.details, (function (param) {
                  if (param[0] === "header_caption") {
                    return param[1];
                  }
                  
                }));
          const url = details.logo_url;
          const email = details.support_email;
          const phone = details.support_phone;
          const url$1 = details.support_url;
          tmp$1 = JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  url !== undefined ? JsxRuntime.jsx("img", {
                                          className: "w-16 h-16",
                                          src: url
                                        }) : null,
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                children: etpInfo.name
                                              }),
                                          email !== undefined ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-gray-medium",
                                                  children: JsxRuntime.jsx("a", {
                                                        children: email,
                                                        href: "mailto:" + email
                                                      })
                                                }) : null,
                                          phone !== undefined ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-gray-medium",
                                                  children: Formating.formatPhone(phone)
                                                }) : null
                                        ],
                                        className: "ml-4"
                                      })
                                ],
                                className: "flex"
                              }),
                          url$1 !== undefined ? JsxRuntime.jsx("a", {
                                  children: JsxRuntime.jsx("img", {
                                        src: StaticAsset.src("/static/icons/share.svg")
                                      }),
                                  href: url$1
                                }) : null
                        ],
                        className: "p-6 flex items-center justify-between"
                      }),
                  JsxRuntime.jsx("hr", {}),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: "text-gray-medium",
                                      children: "Номер заказа"
                                    }),
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: order.order_num
                                    })
                              ],
                              className: "flex justify-between"
                            }),
                        className: "p-6"
                      }),
                  caption ? JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                children: caption.hd
                              }),
                          className: "bg-gray-main px-6 py-4"
                        }) : null
                ],
                className: "w-full md:w-112 bg-white mt-6 md:mt-10 rounded-md shadow-card"
              });
        } else {
          tmp$1 = null;
        }
      } else {
        tmp$1 = null;
      }
      tmp = JsxRuntime.jsxs("div", {
            children: [
              tmp$1,
              Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(order.receipts, (function (i, rcp) {
                          const rc = rcp.receipt;
                          if (rc === undefined) {
                            return null;
                          }
                          const num = rc.receipt_num;
                          const receipt_num = num !== undefined ? num : "";
                          const Key = String(i);
                          return JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                              className: "px-6 py-4",
                                              children: "Чек №" + String(rc.serial_id)
                                            }),
                                        JsxRuntime.jsx("hr", {}),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(Buhta_cabinet__ReceiptBody.make, {
                                                    receipt: rc
                                                  }),
                                              className: "p-6"
                                            })
                                      ],
                                      className: "w-full md:w-112 bg-white mt-2 rounded-md shadow-card",
                                      id: receipt_num
                                    }, Key);
                        })))
            ],
            className: "mt-6 md:mt-10"
          });
    }
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("a", {
                        children: JsxRuntime.jsx("img", {
                              className: "h-6 md:h-7",
                              src: StaticAsset.src("/static/icons/logo-black.svg")
                            }),
                        className: "mt-6 md:mt-10",
                        href: "https://buhta.com"
                      }),
                  tmp,
                  JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                        className: "mt-6 md:mt-10 text-default-gray",
                        children: "© 2014-2024 Бухта"
                      })
                ],
                className: "bg-gray-pale h-100vh flex flex-col items-center font-hauss pb-6 md:pb-10 px-4 overflow-y-auto"
              });
  };
}

function ReceiptETPPage(Props) {
  return make(Props.etp)(Props.id);
}

const make$1 = ReceiptETPPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__Data Not a pure module */
